import React, { useEffect, useRef, memo } from 'react'
import { Box, Grid, TextField, Button, Typography,Stack} from '@mui/material';
import Message from './Message';
import SendIcon from "@mui/icons-material/Send";
// import BoxContainer from './BoxContainer';
import ChatIcon from '../assets/chat icon.png'

const styles = {    
    boxedContainer : {
        scrollBehavior:'smooth',
        minHeight:'255px',
        maxHeight:'270px',
        overflowY: 'auto',
    }
};

const ChatComponent = memo(({messages,handleInputChange,handleSend,input,handleTyping,typing}) => {
    const lastMessageRef = useRef(null);
    useEffect(() => {
        if(lastMessageRef.current){
            lastMessageRef.current.scrollTop = lastMessageRef.current.scrollHeight;
            //lastMessageRef.current.scrollIntoView({ behavior: 'smooth',block: 'start', inline: 'nearest' });
        }
        
      }, [messages]);
  return (
    <>
        <Box 
            component={Stack} 
            direction="row" 
            sx={{ 
                pt: 0.5, 
                pb: 0.5, 
                borderRadius: '4px',
                mb: 0.5,
                border: `1px solid #EAEAEA`,
                bgcolor: '#EAEAEA',
                mt:1
            }}
        >
            <Typography sx={{ fontWeight: 500, pl: 2,fontSize:'0.90rem' }}>Chat</Typography>
        </Box>
        {/* <BoxContainer  maxHeight={'270px'} minHeight={'255px'}> */}
        <div className="boxedContainer" ref={lastMessageRef}  style={styles.boxedContainer } >
            <Box sx={{ flexGrow: 1, overflow: "auto", p: 0.5 }}>
                {messages.map((message) => (
                    <Message  key={message.id} message={message} />
                ))}
                {messages.length <= 0 &&
                    <Box sx={{ flexGrow: 1}}>
                        <img className="chat_icon" alt="chatIcon" src={ChatIcon}  />
                        <Typography sx={{ fontSize: '0.75rem',display:'flex',justifyContent:'center' }}>Start Chat with Technician.</Typography>
                    </Box>
                }
            </Box>
        </div>
        {/* <div ref={lastMessageRef} /> */}
        {/* </BoxContainer> */}
        <div className="messageTyping">
            { typing?.data?.message?.data?.entity?.message_text &&
                <div className="bubble">
                    <div className="ellipsis one"></div>
                    <div className="ellipsis two"></div>
                    <div className="ellipsis three"></div>
                </div>
            }
        </div>
        <Box sx={{ p: 2, backgroundColor: "background.default" }}>
              <Grid container spacing={2}>
                  <Grid item xs={9}>
                      <TextField 
                          size="small"
                          fullWidth
                          placeholder="Type a message"
                          variant="outlined"
                          value={input}
                          onChange={handleInputChange} 
                          //onKeyDown={handleTyping}  
                          //onBlur={handleInputChange}
                          className='chatBox'
                          />
                  </Grid>
                  <Grid item xs={3}>
                      <Button
                          className='chatSendbutton'
                          //fullWidth
                          color="primary"
                          variant="contained"
                          endIcon={<SendIcon fontSize='small' />}
                          onClick={handleSend}
                      >
                          Send
                      </Button>
                  </Grid>
              </Grid>
          </Box></>
  )
});

export default ChatComponent